module.exports = __webpack_public_path__ + "static/media/arrowGreenSend@3x.2806b44b.png";